export default "__VITE_ASSET__PwTbizfV__"